import { createIcon } from '@chakra-ui/icons';

export const DateIcon = createIcon({
  displayName: 'DateIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M0.533203 22.5C0.533203 23.0186 0.952 23.4375 1.47037 23.4375H23.0252C23.5436 23.4375 23.9624 23.0186 23.9624 22.5V10.1953H0.533203V22.5ZM23.0252 2.10938H18.1051V0.234375C18.1051 0.105469 17.9997 0 17.8708 0H16.2308C16.1019 0 15.9965 0.105469 15.9965 0.234375V2.10938H8.49913V0.234375C8.49913 0.105469 8.39369 0 8.26483 0H6.62479C6.49593 0 6.3905 0.105469 6.3905 0.234375V2.10938H1.47037C0.952 2.10938 0.533203 2.52832 0.533203 3.04688V8.20312H23.9624V3.04688C23.9624 2.52832 23.5436 2.10938 23.0252 2.10938Z"
      fill="currentColor"
    />
  ),
});
